module.exports = __webpack_public_path__ + "img/icon-close.be54aa73.svg";